import {createApi} from "@reduxjs/toolkit/dist/query/react"
import {apiQuery} from "../../utils/api-config";
import {Response} from "../../types/response/Response";
import {PrintCalculateDTO} from "../../types/print/PrintCalculateDTO";
import {PrintRequestParams, PrintsPageableDTO} from "../../types/print/PrintDTO";
import {PrintCreateDTO} from "../../types/print/PrintCreateDTO";
import {PrintNotificationDTO} from "../../types/print/PrintNotificationDTO";
import {convertParam, DeleteParams} from "../../types/utils/Constants";
import {AccountNotificationDTO} from "../../types/account/AccountDTO";


export const printApi = createApi({
    reducerPath: "print",
    baseQuery: apiQuery,
    tagTypes: ["printCategories", "prints", "notification", "accounts-notification"],
    endpoints: builder => ({
        calculatePrint: builder.mutation<Response<PrintCalculateDTO>, Partial<number | undefined>>({
            query: (product_id) => `/prints/product/${product_id}/calculate`,
        }),
        calculateExistingPrint: builder.mutation<Response<PrintCalculateDTO>, Partial<number | undefined>>({
            query: (print_id) => `/prints/${print_id}/calculate`,
        }),
        getPrints: builder.query<Response<PrintsPageableDTO>, Partial<PrintRequestParams>>({
            query: (param) => `/prints?account_id=${param.account_id}&page=${param.page}&size=${param.size}${convertParam('types', param.types)}`,
            providesTags: ["prints"],
        }),
        createPrint: builder.mutation<void, Partial<PrintCreateDTO>>({
            query: (body) => ({
                url: '/prints',
                method: 'POST',
                body
            }),
            invalidatesTags: ["prints"]
        }),
        deletePrint: builder.mutation<void, Partial<DeleteParams>>({
            query: (params) => ({
                url: `/prints/${params.id}`,
                method: "DELETE"
            }),
            invalidatesTags: ["prints", "accounts-notification"]
        }),
        deletePrintByAccountIds: builder.mutation<void, Partial<DeleteParams>>({
            query: (params) => ({
                url: `/prints?account_ids=${params.accountId}`,
                method: "DELETE"
            }),
            invalidatesTags: ["prints", "accounts-notification"]
        }),
        getAccountsWithNotification: builder.query<Response<AccountNotificationDTO[]>, Partial<void>>({
            query: () => '/accounts/notification',
            providesTags: ["accounts-notification"],
        }),

        getPrintsNotification: builder.query<Response<PrintNotificationDTO[]>, void>({
            query: () => "/prints/notification",
            providesTags: ["notification"]
        })
    })
})

export const {
    useCalculatePrintMutation,
    useCalculateExistingPrintMutation,
    useGetPrintsQuery,
    useLazyGetPrintsQuery,
    useCreatePrintMutation,
    useDeletePrintMutation,
    useLazyGetAccountsWithNotificationQuery,
    useDeletePrintByAccountIdsMutation,
    useGetPrintsNotificationQuery
} = printApi
